import { render, staticRenderFns } from "./PrestigeHeader.vue?vue&type=template&id=03a0b647&scoped=true&"
import script from "./PrestigeHeader.vue?vue&type=script&lang=js&"
export * from "./PrestigeHeader.vue?vue&type=script&lang=js&"
import style0 from "./PrestigeHeader.vue?vue&type=style&index=0&id=03a0b647&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a0b647",
  null
  
)

export default component.exports